
export const navigation = {
  home: 'Home',
  menu: 'Menu',
  about: 'Chi Siamo',
  contact: 'Contatti',
  bookTable: 'Prenota Tavolo'
};

export const hero = {
  welcome: 'Benvenuti a Rosmarino',
  subtitle: 'Autentica cucina italiana fatta con amore e tradizione',
  viewMenu: 'Vedi Menu',
  reserveTable: 'Prenota Tavolo'
};

export const featuredDishes = {
  title: 'I Nostri Piatti Signature',
  subtitle: 'Scopri i sapori autentici d\'Italia con le nostre specialità preparate con cura, realizzate con i migliori ingredienti importati e ricette tradizionali di famiglia.',
  carbonara: {
    name: 'Pasta Carbonara',
    description: 'Classica pasta romana con uova, pecorino, pancetta e pepe nero'
  },
  margherita: {
    name: 'Pizza Margherita',
    description: 'Pizza cotta nel forno a legna con pomodori San Marzano, mozzarella fresca e basilico'
  },
  ossobuco: {
    name: 'Osso Buco',
    description: 'Stinco di vitello brasato lentamente con risotto alla milanese e gremolata'
  },
  orderNow: 'Ordina Ora'
};

export const about = {
  title: 'La Nostra Storia',
  paragraph1: 'Fondato dalla famiglia Benedetti a Ciampino, Rosmarino serve autentica cucina italiana da oltre tre decenni nella provincia di Roma. La nostra passione per le ricette tradizionali e gli ingredienti freschi crea un\'esperienza culinaria indimenticabile.',
  paragraph2: 'Ogni piatto è preparato con amore, utilizzando tecniche tradizionali tramandate di generazione in generazione. Dalla nostra pasta fatta in casa alle nostre pizze cotte nel forno a legna, portiamo il vero sapore d\'Italia alla vostra tavola. Recentemente abbiamo aperto la nostra nuova sede ad Ariccia per servire ancora più clienti nella zona di Roma.',
  stats: {
    experience: 'Anni di Esperienza',
    customers: 'Clienti Soddisfatti',
    recipes: 'Ricette Tradizionali'
  }
};

export const menu = {
  title: 'Il Nostro Menu',
  subtitle: 'Scopri le nostre specialità italiane autentiche',
  antipasti: {
    title: 'Antipasti',
    items: {
      antipastoCasa: {
        name: 'Antipasto della Casa',
        description: 'Selezione di salumi, formaggi, olive e verdure arrostite'
      },
      bruschetta: {
        name: 'Bruschetta al Pomodoro',
        description: 'Pane grigliato con pomodori freschi, basilico e aglio'
      },
      carpaccio: {
        name: 'Carpaccio di Manzo',
        description: 'Fette sottili di manzo con rucola, parmigiano e limone'
      }
    }
  },
  primi: {
    title: 'Primi Piatti',
    items: {
      vongole: {
        name: 'Spaghetti alle Vongole',
        description: 'Spaghetti con vongole fresche, vino bianco e prezzemolo'
      },
      risotto: {
        name: 'Risotto ai Porcini',
        description: 'Risotto cremoso con funghi porcini e olio al tartufo'
      },
      lasagne: {
        name: 'Lasagne della Nonna',
        description: 'Lasagne tradizionali con ragù, besciamella e parmigiano'
      }
    }
  },
  viewFullMenu: 'Vedi Menu Completo'
};

export const contact = {
  title: 'Vieni a Trovarci',
  subtitle: 'Vivi l\'autentica ospitalità italiana',
  locations: {
    ciampino: {
      title: 'Ciampino - Sede Storica',
      address: 'Piazza Trento e Trieste 3\n00043 Ciampino (RM)'
    },
    ariccia: {
      title: 'Ariccia - Nuova Sede',
      address: 'Viale Antonietta Chigi 16\n00072 Ariccia (RM)'
    }
  },
  phone: {
    title: 'Telefono',
    ciampino: '06 45763624',
    ariccia: '06 45769762'
  },
  hours: {
    title: 'Orari',
    ciampino: 'Chiuso Lunedì\nMar-Gio: 15:30-00:00\nVen-Dom: 11:00-00:00',
    ariccia: 'Chiuso Lunedì\nMar-Dom: 11:00-00:00'
  }
};

export const footer = {
  description: 'Autentica cucina italiana fatta con amore e tradizione.',
  quickLinks: 'Link Rapidi',
  contactInfo: 'Informazioni di Contatto',
  locations: {
    ciampino: 'Ciampino: Piazza Trento e Trieste 3',
    ariccia: 'Ariccia: Viale Antonietta Chigi 16'
  },
  newsletter: {
    title: 'Newsletter',
    description: 'Iscriviti per offerte speciali e aggiornamenti',
    placeholder: 'La tua email',
    subscribe: 'Iscriviti'
  },
  copyright: '© 2024 Ristorante Rosmarino. Tutti i diritti riservati.',
  poweredBy: 'Website Builder'
};

export default {
  navigation,
  hero,
  featuredDishes,
  about,
  menu,
  contact,
  footer
};